import { useParams } from "react-router-dom";
import { useState } from "react";
import SearchBar from "@/components/SearchBar.js";
import GenericBanner from "@/components/GenericBanner";
import Footer from "@/layout/Footer";
import { capitalizeFirstLetter } from "@/utils/StringUtils";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "@/components/Card";
import { Navigation, Pagination } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ProductDetails = () => {
	const { productId } = useParams();
	const productCards = [
		{
			id: 1,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 2,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 3,
			image: "/assets/trend-details/card3.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
		{
			id: 4,
			image: "/assets/search/priceFilter/image1.svg",
			compareButtonIcon: "/assets/search/priceFilter/compareButton.svg",
			title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
			price: "$9,199.99 US",
			shipping: "Free Shipping Today!",
			availability: "Available on",
		},
	];
	const productCardOne = {
		image: "/assets/product-details/image1.svg",
		title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
		price: "$9,199.99 US",
		shipping: "Free Shipping Today!",
		availability: "Available on",
	};

	const productCardTwo = {
		image: "/assets/product-details/image1.svg",
		title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
		price: "$9,199.99 US",
		shipping: "Free Shipping Today!",
		availability: "Available on",
	};

	const productCardThree = {
		image: "/assets/product-details/image1.svg",
		title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
		price: "$9,199.99 US",
		shipping: "Free Shipping Today!",
		availability: "Available on",
	};

	const productCardFour = {
		image: "/assets/product-details/image1.svg",
		title: "Espresso Machines 20 Bar Fast Heating Expresso Coffee Machine",
		price: "$9,199.99 US",
		shipping: "Free Shipping Today!",
		availability: "Available on",
	};
	const [open, setOpen] = useState(false);

	const sortOptions = [
		"Featured",
		"Price: Low to High",
		"Price: High to Low",
		"Newest Arrivals",
		"Best Sellers",
	];
	const colorClassMap = {
		Alibaba: "bg-[#FF5A0033]",
		Walmart: "bg-[#0071DC33]",
		Ebay: "bg-[#86B81733]",
		Aliexpress: "bg-[#E4322533]",
		Etsy: "bg-[#F5650233]",
		Amazon: "bg-[#FF990033]",
	};

	const bgColorClass =
		colorClassMap[capitalizeFirstLetter(productId)] || "bg-[#D2DCD1]";

	return (
		<>
			<SearchBar />
			<div className="flex flex-col items-center gap-[30px]">
				<GenericBanner
					iconSrc={`/assets/product/xl/${productId}Logo.svg`}
					iconSize={{ width: "w-[160px]", height: "h-[48px]" }}
					title={`${capitalizeFirstLetter(productId)} Dropshipping Product Finder`}
					subtitle="+10,000 products listed"
					description="Find trending products for dropshipping among trusted and reliable suppliers across the globe."
					bgColor={bgColorClass}
				/>
				<div className="flex flex-col w-full xl:w-[90%] mx-auto  h-auto  gap-[21px] hidden my-[20px] lg:flex">
					<div className="flex items-center justify-between w-full">
						{/* Breadcrumbs - now in one line */}
						<div className="flex items-center gap-[4px]">
							<div className="h-[20px] flex items-center justify-between px-1">
								<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
									Electronic
								</span>
								{/* Icon */}
								<img
									src="/assets/search/Icons/bread_crum_arrow.svg"
									alt="Electronic"
									className="w-[10px] h-[10px] ml-1"
								/>
							</div>
							<div className="h-[20px] flex items-center justify-between px-1">
								<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
									Gadgets
								</span>
								<img
									src="/assets/search/Icons/bread_crum_arrow.svg"
									alt="Gadgets"
									className="w-[10px] h-[10px] ml-1"
								/>
							</div>
							<div className="h-[20px] flex items-center justify-between px-1">
								<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
									Smart Watches
								</span>
								<img
									src="/assets/search/Icons/bread_crum_arrow.svg"
									alt="Smart Watches"
									className="w-[10px] h-[10px] ml-1"
								/>
							</div>
						</div>

						<div className="relative inline-block">
							<button
								onClick={() => setOpen(!open)}
								className="w-[122px] h-[32px] flex items-center justify-between border border-[#193D34] rounded-[24px] px-2 gap-2"
							>
								<img
									src="/assets/product/mobile/sortIconStart.svg"
									alt="start icon"
									className="w-[16px] h-[16px]"
								/>
								<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34] text-center">
									Sort by
								</span>
								<img
									src="/assets/product/mobile/sortIconEnd.svg"
									alt="end icon"
									className="w-[16px] h-[16px]"
								/>
							</button>

							{open && (
								<div className="absolute w-[198px] h-auto top-[40px] right-0 bg-[#E8ECEB] border border-gray-200 rounded-[4px] shadow-lg z-50">
									{sortOptions.map((option, idx) => (
										<div
											key={idx}
											className="px-4 py-2 text-[12px] text-[#193D34] font-[400] font-montserrat leading-[100%] cursor-pointer hover:bg-[#CFE6A2]"
											onClick={() => {
												console.log("Selected:", option);
												setOpen(false);
											}}
										>
											{option}
										</div>
									))}
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto  gap-[21px] hidden my-[20px] lg:flex mt-[20px] relative">
					{/* Cards container header */}
					<div className="w-full h-[52px] flex items-center justify-between">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Top Winning Dropshipping Products On{" "}
							{capitalizeFirstLetter(productId)}
						</h1>
					</div>

					{/* Swiper container */}
					<div className="w-full relative mt-8">
						{/* Navigation Buttons */}
						<button className="custom-prev-row1 absolute left-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronLeft size={24} className="text-white" />
						</button>

						<button className="custom-next-row1 absolute right-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper */}
						<Swiper
							modules={[Navigation]}
							slidesPerView={3}
							spaceBetween={20}
							breakpoints={{
								1920: {
									spaceBetween: 10,
								},
							}}
							navigation={{
								nextEl: ".custom-next-row1",
								prevEl: ".custom-prev-row1",
							}}
							className="w-full"
						>
							{productCards.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="priceFilter" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto  gap-[21px] hidden my-[20px] lg:flex mt-[20px] relative">
					{/* Cards container header */}
					<div className="w-full h-[52px] flex items-center justify-between">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Top Trending Dropshipping Products On{" "}
							{capitalizeFirstLetter(productId)}
						</h1>
					</div>

					{/* Swiper container */}
					<div className="w-full relative">
						{/* Navigation Buttons */}
						<button className="custom-prev-row2 absolute left-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronLeft size={24} className="text-white" />
						</button>

						<button className="custom-next-row2 absolute right-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper */}
						<Swiper
							modules={[Navigation]}
							slidesPerView={3}
							spaceBetween={20}
							navigation={{
								nextEl: ".custom-next-row2",
								prevEl: ".custom-prev-row2",
							}}
							className="w-full"
						>
							{productCards.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="priceFilter" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
				<div className="flex flex-col w-full xl:w-[90%] mx-auto h-auto  gap-[21px] hidden my-[20px] lg:flex mt-[20px] relative">
					{/* Cards container header */}
					<div className="w-full h-[52px] flex items-center justify-between">
						{/* Heading */}
						<h1 className="font-montserrat font-semibold text-[28px] leading-[32px] text-[#193D34]">
							Product With Best Customer Reviews{" "}
							{capitalizeFirstLetter(productId)}
						</h1>
					</div>

					{/* Swiper container */}
					<div className="w-full relative">
						{/* Navigation Buttons */}
						<button className="custom-prev-row3 absolute left-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronLeft size={24} className="text-white" />
						</button>

						<button className="custom-next-row3 absolute right-[-40px] top-1/2 -translate-y-1/2 w-[40px] h-[40px] p-[8px] rounded-full shadow-md bg-[#47645D] flex items-center justify-center z-10 hover:bg-[#3A554E] transition-colors swiper-button-disabled:opacity-50 swiper-button-disabled:cursor-not-allowed">
							<ChevronRight size={24} className="text-white" />
						</button>

						{/* Swiper */}
						<Swiper
							modules={[Navigation]}
							slidesPerView={3}
							spaceBetween={20}
							navigation={{
								nextEl: ".custom-next-row3",
								prevEl: ".custom-prev-row3",
							}}
							className="w-full"
						>
							{productCards.map((card, index) => (
								<SwiperSlide key={index}>
									<Card variant="priceFilter" content={card} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
				<div className="flex flex-col  w-full xl:w-[90%] mx-auto h-auto  gap-[21px]  hidden my-[20px] lg:flex mt-[20px]">
					<div className="w-[1230px] h-[826px] left-[85px] flex flex-col gap-[16px] hidden lg:flex">
						<div className="flex flex-col gap-[10px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-bold text-[20px] leading-[32px] tracking-normal text-black align-middle">
								Amazon Dropshipping Automation Software
							</p>

							{/*Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								<strong>
									Rbetraj's Amazon Dropshipping Automation Software
								</strong>
								is a game changer for struggling dropshippers. Importing
								products from Amazon, managing inventory, and fulfilling orders
								has never been this easy. Your manual workload is greatly
								reduced, allowing you to focus on more important things like
								growing your business and expanding into new global markets.
								<br />
								<br />
								While dropshipping is a lucrative business, it doesn't bring
								success overnight. Various factors influence your rate of
								success. It could be the quality of the products you have
								chosen, whether they are trending or not, or if it is really a
								high-profit item. Having a clearer understanding of these
								factors increases your chance of success by multiple folds.
								<br />
								<br />
								When you use{" "}
								<strong>
									Rbetraj's Amazon Dropshipping Product Research Software
								</strong>
								, you expedite the time it takes to achieve your business goals.
								It automates your dropshipping workflow and helps you find
								trending dropshipping products on Amazon. It also points towards
								products with high search volumes that your customers will most
								likely buy. 
								<br />
								<br />
								You can start dropshipping your way to success with these easy
								steps.
							</p>
						</div>
						<div className="flex flex-col gap-[1px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Connect:
							</p>

							{/*Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								Launch your dropshipping business in minutes. Connect your store
								to our Amazon Dropshipping Automation Software. Pick and find
								winning dropshipping products on Amazon. Our product finder tool
								will help you filter through thousands of products and pick the
								ones with great customer reviews and products currently trending
								on Amazon.
							</p>
						</div>
						<div className="flex flex-col gap-[1px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Automate:
							</p>

							{/*Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								Import products to your store in one click. Automate inventory
								management and fulfil your orders on time, every time! No more
								manual imports of each product that might otherwise take hours. 
							</p>
						</div>
						<div className="flex flex-col gap-[1px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Integrate: 
							</p>

							{/*Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								Integrate all your product details within minutes! It's as
								simple as that. You need not key in every piece of information,
								such as product title, description, pricing, shipping details,
								images, colour variants, etc. Our Amazon Dropshipping Automation
								Software will do all these tedious tasks for you by integrating
								details from your supplier store to your dropshipping store.
							</p>
						</div>

						<div className="flex flex-col gap-[2px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Leverage Real-time Updates On Price Changes
							</p>

							{/*Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								No more second-guessing price changes for products chosen from
								your supplier's store. Our automated software monitors price
								changes in your supplier's store in real-time and every price
								change is automatically updated in your dropshipping store.
							</p>
						</div>

						<div className="flex flex-col gap-[2px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Always Keep Track Of Stock in Your Supplier's Store
							</p>

							{/*Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								Many drop shippers face this challenge. Manual dropshipping
								requires you to keep a tab on Amazon's stock. However, with
								automation, our tool automatically automatically updates your
								store's status when Amazon is out of stock. Your store's status
								will also be updated when the stock is filled.
							</p>
						</div>
						<div className="flex flex-col gap-[2px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Find Trending Dropshipping Products on Amazon
							</p>

							{/*Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								Our Amazon Dropshipping Product Finder Tool is intuitive, fast,
								and reliable. It churns out accurate results that find trending
								dropshipping products on Amazon based on their profit margin,
								stock availability, popularity, customer reviews, etc. This
								enables most drop shippers to sell high-margin products without
								wasting time manually sourcing them.
							</p>
						</div>
						<div className="flex flex-col gap-[2px]">
							{/* Connect Heading */}
							<p className="font-montserrat font-semibold text-[13px] leading-[24px] tracking-normal text-black">
								Team with Reliable Amazon As Your Dropshipping Supplier
							</p>

							{/*Description */}
							<p className="font-montserrat font-normal text-[12px] leading-[18px] tracking-normal text-black">
								You can easily access a network of trusted suppliers like Amazon
								in the market. Leverage their high-quality products and faster
								shipping times. Automate your Dropshipping Store Today! Make
								Product Sourcing and Importing a Breeze!  Rebtraj's Amazon
								Dropshipping Automation Software will automate your process with
								precision and reduce human errors, which can be costly! Sign up
								and start your dropshipping journey with us!
							</p>
						</div>
					</div>
				</div>
			</div>

			{/* Mobile*/}
			<div className="lg:hidden w-full h-[268px] pt-4 pr-5 pb-4 pl-5 gap-4 bg-[#193D34]">
				{/* Navigation Tabs */}
				<div className="w-[378px] h-[36px] pr-5 pb-2 pl-1 gap-1 flex items-center mt-4">
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Products
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Shops
						</span>
					</div>
					<div className="w-[121px] h-[28px] flex items-center">
						<span className="font-montserrat font-bold text-xl leading-8 text-white">
							Trends
						</span>
					</div>
				</div>

				<div className="w-[338px] h-[40px] rounded-lg border-[1.6px] border-gray-300 overflow-hidden mt-3">
					<div className="relative flex items-center w-full h-full">
						<input
							type="text"
							placeholder="Search product.."
							className="pl-4 pr-12 w-full h-full bg-white text-black placeholder:text-gray-400 outline-none focus:ring-0"
						/>
						<button className="absolute right-0 flex items-center justify-center w-[40px] h-full bg-[#B7D974] hover:bg-[#A9C864] transition-colors">
							<img
								src="/assets/home/topnav/search.png"
								alt="Search"
								className="w-[20px] h-[20px]"
							/>
						</button>
					</div>
				</div>

				<div className="lg:hidden w-[338px] flex flex-wrap items-center mt-6 gap-4">
					{/* Filter By Label */}
					<span className="font-montserrat font-normal text-[16px] leading-[32px] text-[#F6F6F6] whitespace-nowrap">
						Filter By :
					</span>

					{/* Buttons */}
					{[
						"Top Sellers",
						"Only Amazon",
						"Only Alibaba",
						"Top in Marketplace",
					].map((label, index) => (
						<button
							key={index}
							className="object-contain  h-[30px] px-[12px] py-[8px] flex items-center justify-center gap-[10px] rounded-[20px] border border-[#A7C56A] bg-[#47645D]"
						>
							<span className="whitespace-nowrap  font-montserrat font-medium text-[13px] leading-[100%] tracking-[0%] text-center text-white">
								{label}
							</span>
						</button>
					))}
				</div>
			</div>

			<div className="w-full lg:hidden flex flex-col items-center">
				{/* Icon container with background */}
				<div className="w-full h-[130px] flex items-center justify-center bg-[#D2DCD1]">
					<div className="w-[240px] h-[80px] flex items-center justify-center">
						<img
							src={`/assets/product/xl/${productId}Logo.svg`}
							alt="Icon"
							className="max-w-full max-h-full object-center object-contain"
						/>
					</div>
				</div>

				{/* Text content container */}
				<div className="w-full flex items-center justify-center bg-[#E8ECEB] py-4">
					<div className="w-[378px] flex flex-col items-start text-left space-y-1">
						<p className="font-montserrat font-bold text-[20px] leading-[32px] tracking-normal text-[#193D34]">
							{`${capitalizeFirstLetter(productId)} Dropshipping `}
						</p>
						<p className="font-montserrat font-normal text-[12px] leading-[12px] text-[#7A7A7A]">
							+10,000 products listed
						</p>
						<p className="font-montserrat font-semibold text-[12px] leading-[12px] text-[#7A7A7A]">
							Find trending products for dropshipping among trusted and reliable
							suppliers across the globe.
						</p>
					</div>
				</div>
			</div>
			<div className="w-full lg:hidden flex items-center justify-between px-2 my-8">
				{/* Breadcrumbs */}
				<div className="flex items-center space-x-2 overflow-x-auto">
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Trends
						</span>
						<img
							src="/assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Facebook
						</span>
						<img
							src="/assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
					<div className="flex items-center space-x-1">
						<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
							Tagsword
						</span>
						<img
							src="/assets/search/Icons/bread_crum_arrow.svg"
							alt="Arrow"
							className="w-[10px] h-[10px]"
						/>
					</div>
				</div>

				{/* Sort By Button */}
				<button className="w-[122px] h-[32px] flex items-center justify-between border border-[#193D34] rounded-[24px] px-2 gap-2">
					<img
						src="/assets/product/mobile/sortIconStart.svg"
						alt="start icon"
						className="w-[16px] h-[16px]"
					/>
					<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34] text-center">
						Sort by
					</span>
					<img
						src="/assets/product/mobile/sortIconEnd.svg"
						alt="end icon"
						className="w-[16px] h-[16px]"
					/>
				</button>
			</div>
			<div className="lg:hidden flex flex-col w-[100%] h-auto items-center gap-5 sm:gap-5 overflow-hidden mt-3">
				{/* Title at the top */}
				<div className="text-center text-[28px] leading-[32px] font-semibold text-[#193D34] font-[Montserrat]">
					<span className="block">Top Winning</span>
					<span className="block">Dropshipping Products</span>
					<span className="block">On Amazon</span>
				</div>

				{/* Swiper Container */}
				<div className="w-full h-[600px] flex flex-col items-center justify-center relative">
					{/* Custom Navigation Buttons */}
					<img
						src="/assets/home/section3/navigationButtonLeft.svg"
						alt="section3navNone"
						className="custom-prev absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					<img
						src="/assets/home/section3/navigationButtonRight.svg"
						alt="section3navNone"
						className="custom-next absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					{/* Swiper Wrapper */}
					<div className="w-full flex justify-center">
						<Swiper
							modules={[Navigation, Pagination]}
							spaceBetween={10} // Adjusted for better spacing
							slidesPerView={1.2} // Default for small mobiles (320px)
							breakpoints={{
								481: { slidesPerView: 1.5, spaceBetween: 10 }, // Large mobiles
								768: { slidesPerView: 2.5, spaceBetween: 16 }, // Small tablets
								1024: { slidesPerView: 3.5, spaceBetween: 24 }, // Large tablets
							}}
							navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
							pagination={{
								el: ".custom-pagination",
								clickable: true,
								dynamicBullets: true,
							}}
							className="w-full"
						>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardOne}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardTwo}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardThree}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardFour}
								/>
							</SwiperSlide>
						</Swiper>
					</div>

					{/* Custom Pagination Below Swiper */}
					<div className="custom-pagination mt-4 flex justify-center w-full"></div>
				</div>
			</div>
			<div className="lg:hidden flex flex-col w-[100%] h-auto items-center gap-5 sm:gap-5 overflow-hidden mt-3">
				{/* Title at the top */}
				<div className="text-center text-[28px] leading-[32px] font-semibold text-[#193D34] font-[Montserrat]">
					<span className="block">Top Trending</span>
					<span className="block">Dropshipping Products</span>
					<span className="block">On Amazon</span>
				</div>

				{/* Swiper Container */}
				<div className="w-full h-[600px] flex flex-col items-center justify-center relative">
					{/* Custom Navigation Buttons */}
					<img
						src="/assets/home/section3/navigationButtonLeft.svg"
						alt="section3navNone"
						className="custom-prev2 absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					<img
						src="/assets/home/section3/navigationButtonRight.svg"
						alt="section3navNone"
						className="custom-next2 absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					{/* Swiper Wrapper */}
					<div className="w-full flex justify-center">
						<Swiper
							modules={[Navigation, Pagination]}
							spaceBetween={10} // Adjusted for better spacing
							slidesPerView={1.2} // Default for small mobiles (320px)
							breakpoints={{
								481: { slidesPerView: 1.5, spaceBetween: 10 }, // Large mobiles
								768: { slidesPerView: 2.5, spaceBetween: 16 }, // Small tablets
								1024: { slidesPerView: 3.5, spaceBetween: 24 }, // Large tablets
							}}
							navigation={{ nextEl: ".custom-next2", prevEl: ".custom-prev2" }}
							pagination={{
								el: ".custom-pagination",
								clickable: true,
								dynamicBullets: true,
							}}
							className="w-full"
						>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardOne}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardTwo}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardThree}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardFour}
								/>
							</SwiperSlide>
						</Swiper>
					</div>

					{/* Custom Pagination Below Swiper */}
					<div className="custom-pagination mt-4 flex justify-center w-full"></div>
				</div>
			</div>
			<div className="lg:hidden flex flex-col w-[100%] h-auto items-center gap-5 sm:gap-5 overflow-hidden mt-3">
				{/* Title at the top */}
				<div className="text-center text-[28px] leading-[32px] font-semibold text-[#193D34] font-[Montserrat]">
					<span className="block">Product With</span>
					<span className="block">Best Customer</span>
					<span className="block">Review</span>
				</div>

				{/* Swiper Container */}
				<div className="w-full h-[600px] flex flex-col items-center justify-center relative">
					{/* Custom Navigation Buttons */}
					<img
						src="/assets/home/section3/navigationButtonLeft.svg"
						alt="section3navNone"
						className="custom-prev3 absolute left-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					<img
						src="/assets/home/section3/navigationButtonRight.svg"
						alt="section3navNone"
						className="custom-next3 absolute right-[20px] top-1/2 transform -translate-y-1/2 z-10 w-[40px] h-[40px] rounded-full p-2"
					/>

					{/* Swiper Wrapper */}
					<div className="w-full flex justify-center">
						<Swiper
							modules={[Navigation, Pagination]}
							spaceBetween={10} // Adjusted for better spacing
							slidesPerView={1.2} // Default for small mobiles (320px)
							breakpoints={{
								481: { slidesPerView: 1.5, spaceBetween: 10 }, // Large mobiles
								768: { slidesPerView: 2.5, spaceBetween: 16 }, // Small tablets
								1024: { slidesPerView: 3.5, spaceBetween: 24 }, // Large tablets
							}}
							navigation={{ nextEl: ".custom-next3", prevEl: ".custom-prev3" }}
							pagination={{
								el: ".custom-pagination",
								clickable: true,
								dynamicBullets: true,
							}}
							className="w-full"
						>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardOne}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardTwo}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardThree}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<Card
									variant="product_details_mobile"
									content={productCardFour}
								/>
							</SwiperSlide>
						</Swiper>
					</div>

					{/* Custom Pagination Below Swiper */}
					<div className="custom-pagination mt-4 flex justify-center w-full"></div>
				</div>
			</div>
			<div className="flex flex-col w-full h-auto gap-[16px] block lg:hidden my-[20px] px-4">
				<p className="font-montserrat font-bold text-[18px] leading-[28px] text-black">
					Amazon Dropshipping Automation Software
				</p>

				<p className="font-montserrat text-[14px] leading-[20px] text-black">
					<strong>Rbetraj's Amazon Dropshipping Automation Software</strong> is
					a game changer for struggling dropshippers. Importing products from
					Amazon, managing inventory, and fulfilling orders has never been this
					easy. Your manual workload is greatly reduced, allowing you to focus
					on more important things like growing your business and expanding into
					new global markets.
					<br />
					<br />
					While dropshipping is a lucrative business, it doesn't bring success
					overnight. Various factors influence your rate of success. It could be
					the quality of the products you have chosen, whether they are trending
					or not, or if it is really a high-profit item. Having a clearer
					understanding of these factors increases your chance of success by
					multiple folds.
					<br />
					<br />
					When you use{" "}
					<strong>
						Rbetraj's Amazon Dropshipping Product Research Software
					</strong>
					, you expedite the time it takes to achieve your business goals. It
					automates your dropshipping workflow and helps you find trending
					dropshipping products on Amazon. It also points towards products with
					high search volumes that your customers will most likely buy.
					<br />
					<br />
					You can start dropshipping your way to success with these easy steps.
				</p>

				<div className="mt-4">
					<p className="font-semibold text-[14px] text-black">Connect:</p>
					<p className="text-[13px] text-black">
						Launch your dropshipping business in minutes. Connect your store to
						our Amazon Dropshipping Automation Software. Pick and find winning
						dropshipping products on Amazon. Our product finder tool will help
						you filter through thousands of products and pick the ones with
						great customer reviews and products currently trending on Amazon.
					</p>
				</div>

				<div className="mt-4">
					<p className="font-semibold text-[14px] text-black">Automate:</p>
					<p className="text-[13px] text-black">
						Import products to your store in one click. Automate inventory
						management and fulfil your orders on time, every time! No more
						manual imports of each product that might otherwise take hours.
					</p>
				</div>

				<div className="mt-4">
					<p className="font-semibold text-[14px] text-black">Integrate:</p>
					<p className="text-[13px] text-black">
						Integrate all your product details within minutes! It's as simple as
						that. You need not key in every piece of information, such as
						product title, description, pricing, shipping details, images,
						colour variants, etc. Our Amazon Dropshipping Automation Software
						will do all these tedious tasks for you by integrating details from
						your supplier store to your dropshipping store.
					</p>
				</div>

				<div className="mt-4">
					<p className="font-semibold text-[14px] text-black">
						Leverage Real-time Updates On Price Changes:
					</p>
					<p className="text-[13px] text-black">
						No more second-guessing price changes for products chosen from your
						supplier's store. Our automated software monitors price changes in
						your supplier's store in real-time and every price change is
						automatically updated in your dropshipping store.
					</p>
				</div>

				<div className="mt-4">
					<p className="font-semibold text-[14px] text-black">
						Always Keep Track Of Stock in Your Supplier's Store:
					</p>
					<p className="text-[13px] text-black">
						Many drop shippers face this challenge. Manual dropshipping requires
						you to keep a tab on Amazon's stock. However, with automation, our
						tool automatically updates your store's status when Amazon is out of
						stock. Your store's status will also be updated when the stock is
						filled.
					</p>
				</div>

				<div className="mt-4">
					<p className="font-semibold text-[14px] text-black">
						Find Trending Dropshipping Products on Amazon:
					</p>
					<p className="text-[13px] text-black">
						Our Amazon Dropshipping Product Finder Tool is intuitive, fast, and
						reliable. It churns out accurate results that find trending
						dropshipping products on Amazon based on their profit margin, stock
						availability, popularity, customer reviews, etc. This enables most
						drop shippers to sell high-margin products without wasting time
						manually sourcing them.
					</p>
				</div>

				<div className="mt-4 mb-4">
					<p className="font-semibold text-[14px] text-black">
						Team with Reliable Amazon As Your Dropshipping Supplier:
					</p>
					<p className="text-[13px] text-black">
						You can easily access a network of trusted suppliers like Amazon in
						the market. Leverage their high-quality products and faster shipping
						times. Automate your Dropshipping Store Today! Make Product Sourcing
						and Importing a Breeze! Rebtraj's Amazon Dropshipping Automation
						Software will automate your process with precision and reduce human
						errors, which can be costly! Sign up and start your dropshipping
						journey with us!
					</p>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default ProductDetails;
